import { MetadataTable } from "@components/backoffice/MetadataTable";
import { UrlList } from "@components/backoffice/UrlList";
import { IdentifierRows } from "@modules/Identifiers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ShowMore from "react-show-more";
import { Grid, Header, Segment } from "semantic-ui-react";

export default class SpecialCollectionMetadata extends Component {
  render() {
    const { specialCollectionDetails } = this.props;

    if (!specialCollectionDetails || !specialCollectionDetails.metadata) {
      return (
        <Segment attached className="special-collection-metadata">
          <div>Loading metadata...</div>
        </Segment>
      );
    }

    const { metadata } = specialCollectionDetails;

    const metadataRows = [
      {
        name: "Advisers",
        value:
          metadata.advisers?.map((a) => a.full_name).join(", ") ||
          "Not Specified",
      },
      {
        name: "Completion Year",
        value: metadata.publication_year || "Not Specified",
      },
      {
        name: "Campus",
        value: metadata.academic_info?.campus || "Not Specified",
      },
      {
        name: "Department",
        value: metadata.academic_info?.department || "Not Specified",
      },
      {
        name: "Program",
        value: metadata.academic_info?.program || "Not Specified",
      },
      {
        name: "Identifiers",
        value: metadata.identifiers && (
          <IdentifierRows identifiers={metadata.identifiers} />
        ),
      },
      {
        name: "External URLs",
        value: metadata.urls && <UrlList urls={metadata.urls} />,
      },
    ];

    // Add conditional fields (like EItem does)
    metadata.call_number &&
      metadataRows.push({
        name: "Call Number",
        value: metadata.call_number,
      });

    metadata.source &&
      metadataRows.push({
        name: "Source",
        value: metadata.source,
      });

    return (
      <>
        <Header as="h3" attached="top">
          Metadata
        </Header>
        <Segment attached className="special-collection-metadata" id="metadata">
          <Grid padded columns={2}>
            <Grid.Row>
              <Grid.Column>
                <MetadataTable rows={metadataRows} />
              </Grid.Column>
              <Grid.Column>
                <Header as="h4">Abstract</Header>
                <ShowMore
                  lines={5}
                  more="Show more"
                  less="Show less"
                  anchorClass="button-show-more"
                >
                  {metadata.abstract || "No abstract available."}
                </ShowMore>

                <Header as="h4">Notes</Header>
                <ShowMore
                  lines={5}
                  more="Show more"
                  less="Show less"
                  anchorClass="button-show-more"
                >
                  {metadata.notes || "No notes available."}
                </ShowMore>

                {metadata.internal_notes?.length > 0 && (
                  <>
                    <Header as="h4">Internal Notes</Header>
                    <ShowMore
                      lines={5}
                      more="Show more"
                      less="Show less"
                      anchorClass="button-show-more"
                    >
                      {metadata.internal_notes.map((note, noteIndex) => (
                        <div
                          key={`note-${noteIndex}-${note.field || noteIndex}`}
                          style={{ marginBottom: "8px" }}
                        >
                          <strong>{note.field}:</strong> {note.value}
                          {note.user && <em> (by {note.user})</em>}
                        </div>
                      ))}
                    </ShowMore>
                  </>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </>
    );
  }
}

SpecialCollectionMetadata.propTypes = {
  specialCollectionDetails: PropTypes.object.isRequired,
};
